import { render, staticRenderFns } from "./WebView.vue?vue&type=template&id=528a3b39&scoped=true"
import script from "./WebView.vue?vue&type=script&lang=js"
export * from "./WebView.vue?vue&type=script&lang=js"
import style0 from "./WebView.vue?vue&type=style&index=0&id=528a3b39&prod&lang=less&scoped=true"
import style1 from "./WebView.vue?vue&type=style&index=1&id=528a3b39&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528a3b39",
  null
  
)

export default component.exports